import { jsx } from "react/jsx-runtime";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { validateTidalLicense } from "../../base/index.js";
function AttachMoney(props) {
  return /* @__PURE__ */ jsx(
    AttachMoneyIcon,
    {
      "data-testid": "AttachMoney",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AttachMoney",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
AttachMoney.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "AttachMoney"
};
validateTidalLicense();
export {
  AttachMoney
};
//# sourceMappingURL=AttachMoney.js.map
